module.exports = __webpack_public_path__ + "static/media/DMSerifDisplay-Italic.af28faf7.ttf";